import { render } from "./submenu.vue?vue&type=template&id=5bb98c17&scoped=true"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"

import "./submenu.vue?vue&type=style&index=0&id=5bb98c17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb98c17"]])

export default __exports__